import React, { useEffect, useRef } from 'react';
import MessageBubble from './MessageBubble';
import AssistantInput from './AssistantInput';

function SparkleIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l2.09 6.26L20 10l-5.91 1.74L12 18l-2.09-6.26L4 10l5.91-1.74z" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

function TypingIndicator() {
  return (
    <div className="assistant-typing-indicator">
      <div className="bubble-content">
        <div className="dots">
          <span /><span /><span />
        </div>
      </div>
    </div>
  );
}

function WelcomeState() {
  return (
    <div className="assistant-welcome">
      <div className="assistant-welcome-icon">
        <SparkleIcon />
      </div>
      <h3>Ambaram Assistant</h3>
      <p>Ask me anything about fashion design — tech packs, fabrics, trends, colour theory, and more.</p>
    </div>
  );
}

export default function AssistantPanel({
  onClose,
  messages,
  loading,
  error,
  remaining,
  inputValue,
  onInputChange,
  onSend,
  file,
  onFileChange,
  onFileRemove,
}) {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  return (
    <div className="assistant-panel">
      {/* Header */}
      <div className="assistant-header">
        <div className="assistant-header-info">
          <div className="assistant-avatar">
            <SparkleIcon />
          </div>
          <div className="assistant-title">
            <h4>Ambaram Assistant</h4>
            <p>Fashion Design AI</p>
          </div>
        </div>
        <button className="assistant-close" onClick={onClose} title="Close">
          <CloseIcon />
        </button>
      </div>

      {/* Rate limit indicator */}
      {remaining !== null && (
        <div className="assistant-remaining">
          {remaining} message{remaining !== 1 ? 's' : ''} remaining today
        </div>
      )}

      {/* Messages */}
      <div className="assistant-messages">
        {messages.length === 0 ? (
          <WelcomeState />
        ) : (
          messages.map((msg) => (
            <MessageBubble key={msg.id} message={msg} />
          ))
        )}
        {loading && <TypingIndicator />}
        <div ref={messagesEndRef} />
      </div>

      {/* Error */}
      {error && <div className="assistant-error">{error}</div>}

      {/* Input */}
      <AssistantInput
        value={inputValue}
        onChange={onInputChange}
        onSend={onSend}
        file={file}
        onFileChange={onFileChange}
        onFileRemove={onFileRemove}
        loading={loading}
      />
    </div>
  );
}
